import { computed } from "vue";

export default function ButtonState(obj, errors) {

    const isButtonDisabled = computed(() => {
        let disabled = true;
        for (let prop in obj) {
            if ( prop != 'soldier_id' && (!obj[prop] || errors[prop]) ) {
                disabled = true;
                break;
            }
            disabled = false;
        }
        return disabled;
    });

    return { isButtonDisabled }
}